import { ModalForm } from '@ant-design/pro-components'
import { Button, Descriptions, Divider, Form, Typography, type FormInstance } from 'antd'
import { UserRoundCheck } from 'lucide-react'
import { RoleSelect } from '@/features/authorization/role-select.tsx'

export type AccountPermissionForm = {
  roleIds: string[]
}

type PermissionAccount = {
  email: string
  member: { name: string } | null
}

export function AccountPermissionModal({
  form,
  onClose,
  onSave,
  selected,
  updatePending
}: {
  form: FormInstance<AccountPermissionForm>
  onClose: () => void
  onSave: () => Promise<void>
  selected?: PermissionAccount
  updatePending: boolean
}) {
  return (
    <ModalForm<AccountPermissionForm>
      form={form}
      layout="vertical"
      modalProps={{
        destroyOnHidden: true,
        mask: { closable: false },
        onCancel: onClose
      }}
      onOpenChange={(open) => {
        if (!open) {
          onClose()
        }
      }}
      open={Boolean(selected)}
      scrollToFirstError
      submitter={false}
      title={`权限配置 · ${selected?.member?.name ?? selected?.email ?? ''}`}
      width={600}
    >
      <Descriptions
        column={1}
        items={[
          { key: 'member', label: '成员', children: selected?.member?.name ?? '未绑定成员' },
          {
            key: 'email',
            label: '登录邮箱',
            children: <Typography.Text copyable>{selected?.email}</Typography.Text>
          }
        ]}
        size="small"
      />
      <Divider size="small" />
      <Form.Item
        extra="增删所选角色后保存，将立即替换当前账号的角色配置。"
        label="账号角色"
        name="roleIds"
        rules={[{ message: '至少选择一个角色', min: 1, required: true, type: 'array' }]}
      >
        <RoleSelect disabled={updatePending} />
      </Form.Item>
      <Button
        block
        icon={<UserRoundCheck aria-hidden size={16} />}
        loading={updatePending}
        onClick={() => void onSave()}
        type="primary"
      >
        保存权限配置
      </Button>
    </ModalForm>
  )
}
